<div class="cf-flex-row cf-gap-20">
  <!-- COMMENT: possible buttonClicked event is not needed in this feature -->
  <app-entity-editor
    *ngIf="projectEntity"
    class="cf-fill"
    [entity]="projectEntity"
    (propertyChange)="propertyChanged($event)"
  ></app-entity-editor>
</div>
